import $ from 'jquery';
import {findObjectById, getLocacion} from '../../util';



export class ResultadoExamenApi {
    
    static activar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/resultadoexamen/activar/"+id,
			type: "PUT",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
     static borrar(id, token) {  
       return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken}, 
        	url: getLocacion()+ "/api/resultadoexamen/"+id,
			type: "DELETE",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
				
			}
		});
	}
    
    
    static getResultadoExamenList(pagina, regitrosPorPagina, filtro, showActivos, filtrosCombo, token ) {
        
         return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen?page="+pagina+"&size="+regitrosPorPagina+"&filtro="+filtro+"&activos="+showActivos,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
      
	}
    
    static getResultadoExamenCruso(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/resultadosByCurso/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	} 
    
    
    
    static getResultadoExamen(id, filtro, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/resultados/"+id+"/"+filtro,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    static getResultadoExamenUsuario(id, token ) {  
         return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/"+id,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
        
	}
    
    
    static save(resultadoexamen, token ) {          
      let resultadoexamenEnvio = Object.assign({}, resultadoexamen);
		let comando="POST";
		if (resultadoexamenEnvio.id > 0) {
			comando="PUT";			
		}
        resultadoexamenEnvio.cadena=JSON.stringify(resultadoexamenEnvio.cadena);
		resultadoexamenEnvio=JSON.stringify(resultadoexamenEnvio);
		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: resultadoexamenEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    
    static saveSinCadena(resultadoexamen, token ) {          
      let resultadoexamenEnvio = Object.assign({}, resultadoexamen);
		let comando="POST";
		resultadoexamenEnvio=JSON.stringify(resultadoexamenEnvio);
		return $.ajax({
            headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/sinCadena/",
			type: comando,
			contentType: "application/json; charset=utf-8",
			dataType: "json",
			data: resultadoexamenEnvio,
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
    static getResultadoExamenCombo(token ) {

		return $.ajax({
 headers: {"Authorization": "Bearer " + token.idToken},  
			url: getLocacion()+ "/api/resultadoexamen/combo/",
			statusCode: {
				401: function() {
				   // Only if your server returns a 403 status code can it come in this block. :-)					
					window.location = getLocacion()+'/login';
				}
			}
		});
	}
    
     

    
}